import React, { ReactNode, VideoHTMLAttributes } from 'react';

type Props = {
  img?: string;
  imgAlt?: string;
  mp4?: string;
  ogg?: string;
  webm?: string;
} & VideoHTMLAttributes<HTMLVideoElement>;

export const Video = (props: Props) => {
  const { autoPlay = false, img, imgAlt, loop = false, mp4, ogg, webm, ...rest } = props;

  const sources = Object.entries({ mp4, ogg, webm }).reduce((prev: ReactNode[], [ext, src]) => {
    if (src) {
      return [...prev, <source key={ext} src={src} type={`video/${ext}`} />];
    }
    return prev;
  }, []);

  return (
    <video {...rest} autoPlay={autoPlay} loop={loop}>
      {sources}
      {img && imgAlt && <img src={img} alt={imgAlt} />}
    </video>
  );
};
